export default __webpack_public_path__ + "static/media/mastercard.aaf68647.svg";